export const AnyTargetId: string = '0-Any Target';
